import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/shared/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-course-view',
  templateUrl: './course-view.component.html',
  styleUrls: ['./course-view.component.scss' ,'../../../../../../assets/sass/pages/page-users.scss']
})
export class CourseViewComponent implements OnInit {
  courseId:any
  courseData:any
  // imageUrl=environment.apiUrls.imageUrl;
  imageUrl=environment.apiUrls.course_imageUrl;



  constructor(public apiService:ApiService,private activatedroute:ActivatedRoute) {
    this.activatedroute.paramMap.subscribe(params => { 
      this.courseId = params.get('id'); 
    });
   }

  ngOnInit(): void {
   this.getCourseById()
}

  getCourseById(){
    this.apiService.getCourseById(this.courseId).subscribe((res:any)=>{
      this.courseData=res.data
    })
  }
}
